import {createBrowserHistory} from 'history';
import configureStore from "./configureStore";

const initialState = {};
// Create redux store with history

export const history = createBrowserHistory();
export const store = configureStore(initialState);